import React from "react";

const FinalReassurance = ({ data }) => {
  return (
    <section className="final-reassurance">
      <div className="container">
      <h2>{data?.title}</h2>
<p className="subtitle">{data?.subtitle}</p>
<div className="content">
  {data?.points?.map((point, index) => (
    <p key={index} className="point">{point}</p>
  ))}
</div>
<p className="closing">{data?.closing}</p>

      </div>
    </section>
  );
};

export default FinalReassurance;
